<template>
  <v-flex xs12>
    <v-card class="px-2 py-3">
      <v-flex xs12 px-3 py-3 v-if="err">
        <v-alert type="error" :value="true">{{err}}</v-alert>
      </v-flex>
      <v-layout row v-if="licenseUsage" wrap justify-space-between>
        <v-flex xs12 class="month-year layout row wrap">
          <p class="pa-3 ma-0"  v-if='licenseUsage.month'>
            {{$lang.labels.month}}:
            <span class="ml-2">{{months[parseInt(licenseUsage.month, 10) - 1].text }}</span>
          </p>
          <p class="pa-3 ma-0"  v-if='licenseUsage.year'>
            {{$lang.labels.year}}:
            <span class="ml-2">{{licenseUsage.year}}</span>
          </p>
          <p class="pa-3 ma-0"  v-if='licenseUsage.type === "monthlyaggregated"'>
            {{$lang.labels.rgu}}:
            <span class="ml-2">{{ counter }}</span>
          </p>
        </v-flex>
        <v-flex xs12>
          <div class="v-table__overflow pa-3">
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th></th>
                  <th>{{$lang.license.productionLicenses}}</th>
                  <th>{{$lang.license.testLicense}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{{$lang.license.totalActive}}</th>
                  <td>{{licenseUsage.noOfActiveProdLicenses || 0}}</td>
                  <td>{{licenseUsage.noOfActiveTestLicenses || 0}}</td>
                </tr>
                <tr>
                  <th>{{$lang.license.totalConcurrent}}</th>
                  <td>{{licenseUsage.concurrentUsersForProdLicense || 0}}</td>
                  <td>{{licenseUsage.concurrentUsersForTestLicense || 0}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="v-table__overflow pa-3">
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th></th>
                  <th>{{$lang.license.active}}</th>
                  <th>{{$lang.license.inactive}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{{$lang.license.registeredUsers}}</th>
                  <td>{{licenseUsage.noOfActiveUsers || 0}}</td>
                  <td>{{licenseUsage.noOfInactiveUsers || 0}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="v-table__overflow pa-3">
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th></th>
                  <th>{{$lang.license.active}}</th>
                  <th>{{$lang.license.inactive}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{{$lang.license.domains}}</th>
                  <td>{{licenseUsage.domainResourceDetails ? licenseUsage.domainResourceDetails.noOfActiveDomains : 0}}</td>
                  <td>{{licenseUsage.domainResourceDetails ? licenseUsage.domainResourceDetails.noOfInactiveDomains : 0}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="v-table__overflow pa-3" v-if="licenseUsage.webSpaceDetails">
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th>{{$lang.license.webSpaceTypes}}</th>
                  <th>{{$lang.license.active}}</th>
                  <th>{{$lang.license.inactive}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{{$lang.license.premium}}</th>
                  <td>{{licenseUsage.webSpaceDetails.premium ? licenseUsage.webSpaceDetails.premium.noOfActiveWebSpaces : 0}}</td>
                  <td>{{licenseUsage.webSpaceDetails.premium ? licenseUsage.webSpaceDetails.premium.noOfInactiveWebSpaces : 0}}</td>
                </tr>
                <tr>
                  <th>{{$lang.license.basic}}</th>
                  <td>{{licenseUsage.webSpaceDetails.basic ? licenseUsage.webSpaceDetails.basic.noOfActiveWebSpaces : 0}}</td>
                  <td>{{licenseUsage.webSpaceDetails.basic ? licenseUsage.webSpaceDetails.basic.noOfInactiveWebSpaces : 0}}</td>
                </tr>
                <tr>
                  <th>{{$lang.license.link}}</th>
                  <td>{{licenseUsage.webSpaceDetails.link ? licenseUsage.webSpaceDetails.link.noOfActiveWebSpaces : 0}}</td>
                  <td>{{licenseUsage.webSpaceDetails.link ? licenseUsage.webSpaceDetails.link.noOfInactiveWebSpaces : 0}}</td>
                </tr>
                <tr>
                  <th>{{$lang.license.custom}}</th>
                  <td>{{licenseUsage.webSpaceDetails.custom ? licenseUsage.webSpaceDetails.custom.noOfActiveWebSpaces : 0}}</td>
                  <td>{{licenseUsage.webSpaceDetails.custom ? licenseUsage.webSpaceDetails.custom.noOfInactiveWebSpaces : 0}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="v-table__overflow pa-3" v-if="licenseUsage.webShopResourceDetails">
            <table class="v-datatable v-table theme--light my-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{{$lang.license.active}}</th>
                  <th>{{$lang.license.inactive}}</th>
                  <th v-if='licenseUsage.type === "monthlyaggregated"' class="customHeader">
                    <td class="topHeader">{{$lang.header.webshop}}</td>
                    <td class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.orders}}</td>
                  </th>
                  <th v-if='licenseUsage.type === "monthlyaggregated"' class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.totalAmount}}</th>
                  <th v-if='licenseUsage.type === "monthlyaggregated"' class="customHeader">
                    <td class="topHeader">{{$lang.header.orderingApp}}</td>
                    <td class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.orders}}</td>
                  </th>
                  <th v-if='licenseUsage.type === "monthlyaggregated"' class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.totalAmount}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{{$lang.license.webShopRes}}</th>
                  <td>{{licenseUsage.webShopResourceDetails.noOfActiveWebShopResources || 0}}</td>
                  <td>{{licenseUsage.webShopResourceDetails.noOfInactiveWebShopResources || 0}}</td>
                  <td
                    v-if='licenseUsage.type === "monthlyaggregated"'
                    class="text-xs-center">
                    {{ licenseUsage.webShopResourceDetails.ordersData.webshop ? licenseUsage.webShopResourceDetails.ordersData.webshop.noOfOrders : '-'}}
                  </td>
                  <td
                    v-if='licenseUsage.type === "monthlyaggregated"'
                    class="text-xs-center">
                    {{ licenseUsage.webShopResourceDetails.ordersData.webshop ? licenseUsage.webShopResourceDetails.ordersData.webshop.ordersSum : '-' }}
                  </td>
                  <td
                    v-if='licenseUsage.type === "monthlyaggregated"'
                    class="text-xs-center">
                    {{licenseUsage.webShopResourceDetails.ordersData['ordering app'] ? licenseUsage.webShopResourceDetails.ordersData['ordering app'].noOfOrders : '-' }}
                  </td>
                  <td
                    v-if='licenseUsage.type === "monthlyaggregated"'
                    class="text-xs-center">
                    {{licenseUsage.webShopResourceDetails.ordersData['ordering app'] ? licenseUsage.webShopResourceDetails.ordersData['ordering app'].ordersSum : '-' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-flex>
        <v-flex xs12 v-if="licenseUsage.userDetails">
          <div class="v-table__overflow pa-3">
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th style="width: auto;">{{$lang.license.category}}</th>
                  <th>{{$lang.license.module}}</th>
                  <th>{{$lang.license.users}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style="width: auto;">{{$lang.license.moon}}</th>
                  <th>{{$lang.license.paymentM}}</th>
                  <td>{{licenseUsage.userDetails['Payment Management'] ? licenseUsage.userDetails['Payment Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.contactM}}</th>
                  <td>{{licenseUsage.userDetails['Contact Management'] ? licenseUsage.userDetails['Contact Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.reportsM}}</th>
                  <td>{{licenseUsage.userDetails['Reports Management'] ? licenseUsage.userDetails['Reports Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.ordertM}}</th>
                  <td>{{licenseUsage.userDetails['Order Management'] ? licenseUsage.userDetails['Order Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.invoiceM}}</th>
                  <td>{{licenseUsage.userDetails['Invoice Management'] ? licenseUsage.userDetails['Invoice Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.inventoryM}}</th>
                  <td>{{licenseUsage.userDetails['Inventory Management'] ? licenseUsage.userDetails['Inventory Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.drawerHandlerM}}</th>
                  <td>{{licenseUsage.userDetails['Drawer Handler Management'] ? licenseUsage.userDetails['Drawer Handler Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.DBOptM}}</th>
                  <td>{{licenseUsage.userDetails['DB Optimization Management'] ? licenseUsage.userDetails['DB Optimization Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.moonBackupM}}</th>
                  <td>{{licenseUsage.userDetails['Moon Backup Management'] ? licenseUsage.userDetails['Moon Backup Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th style="width: auto;">{{$lang.license.sun}}</th>
                  <th>{{$lang.license.autoJobM}}</th>
                  <td>{{licenseUsage.userDetails['AutoJob Management'] ? licenseUsage.userDetails['AutoJob Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.catalogM}}</th>
                  <td>{{licenseUsage.userDetails['Catalog Management'] ? licenseUsage.userDetails['Catalog Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.printerM}}</th>
                  <td>{{licenseUsage.userDetails['Printer Management'] ? licenseUsage.userDetails['Printer Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.printServerM}}</th>
                  <td>{{licenseUsage.userDetails['PrintServer Management'] ? licenseUsage.userDetails['PrintServer Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.licenseM}}</th>
                  <td>{{licenseUsage.userDetails['License Management'] ? licenseUsage.userDetails['License Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.tableM}}</th>
                  <td>{{licenseUsage.userDetails['Table Management'] ? licenseUsage.userDetails['Table Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.accountM}}</th>
                  <td>{{licenseUsage.userDetails['Account Management'] ? licenseUsage.userDetails['Account Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.companyM}}</th>
                  <td>{{licenseUsage.userDetails['Company Management'] ? licenseUsage.userDetails['Company Management'].noOfUsers : 0}}</td>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$lang.license.sunBackupM}}</th>
                  <td>{{licenseUsage.userDetails['Sun Backup Management'] ? licenseUsage.userDetails['Sun Backup Management'].noOfUsers : 0}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-flex>
      </v-layout>
      <v-flex v-if="licenseUsage" xs12 px-3 py-3>
        <h2 class="title mb-3">{{$lang.license.userCounts}}</h2>
        <template v-if='licenseUsage.type === "monthlyaggregated"'>
          <template v-if="licenseUsage.aggregateUserCountsPerLicenseType">
            <div
              v-if="aggUserCountPerLicenseType.length > 0"
              v-for="(data, index) in aggUserCountPerLicenseType"
              :class="{'mt-3': index === aggUserCountPerLicenseType.length - 1}"
              :key="index">
              <h3 class="sub-title mb-2"><span>{{$lang.license.type}}:</span> {{data.type}}</h3>
              <v-data-table
                :headers="userCOuntPerLTHeaders"
                :items="data.companies"
                hide-actions
                class="elevation-0 my-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="index-w">{{ props.index + 1}}</td>
                  <td class="success--text width-adj">{{ props.item.companyName }}</td>
                  <td class="text-xs-center success--text">{{ props.item.noOfConcurrentUsers}}</td>
                </template>
              </v-data-table>
            </div>
          </template>
          <div v-else>No data available.</div>
        </template>
        <template v-if='licenseUsage.type === "daily" || licenseUsage.type === "monthly"'>
          <template v-if="licenseUsage.userCountsPerLicenseType">
            <div
              v-if="userCountPerLicenseType.length > 0"
              v-for="(data, index) in userCountPerLicenseType"
              :class="{'mt-3': index === userCountPerLicenseType.length - 1}"
              :key="index">
              <h3 class="sub-title mb-2"><span>{{$lang.license.type}}:</span> {{data.type}}</h3>
              <v-data-table
                :headers="userCOuntPerLTHeaders"
                :items="data.companies"
                hide-actions
                class="elevation-0 my-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="index-w">{{ props.index + 1}}</td>
                  <td class="success--text width-adj">{{ props.item.companyName }}</td>
                  <td class="text-xs-center success--text">{{ props.item.noOfConcurrentUsers}}</td>
                </template>
              </v-data-table>
            </div>
          </template>
          <div v-else>No data available.</div>
        </template>
      </v-flex>

      <v-flex v-if="licenseUsage" xs12 px-3 py-3>
        <h2 class="title mb-2">{{$lang.license.domainsByWSType}}</h2>
        <template v-if='licenseUsage.type === "monthlyaggregated"'>
          <template v-if="licenseUsage.aggregateDomainNamesPerWebSpaceType">
            <div
              v-if="aggDomainsPerWebSpace.length > 0"
              v-for="(data, index) in aggDomainsPerWebSpace"
              :class="{'mb-3': index !== aggDomainsPerWebSpace.length - 1}"
              :key="index">
              <h3 class="sub-title mb-2"><span>{{$lang.license.type}}:</span> {{data.type}}</h3>
              <v-data-table
                :headers="domainsPerWSHeaders"
                :items="data.companies"
                hide-actions
                class="elevation-0 my-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="index-w">{{ props.index + 1}}</td>
                  <td class="width-adj">{{ props.item.companyName }}</td>
                  <td class="success--text">{{ props.item.domainNames.join(', ')}}</td>
                </template>
              </v-data-table>
            </div>
          </template>
          <div v-else>No data available.</div>
        </template>

        <template v-if='licenseUsage.type === "daily" || licenseUsage.type === "monthly"'>
          <template v-if="licenseUsage.domainNamesPerWebSpaceType">
            <div
              v-if="getSortedKeys(licenseUsage.domainNamesPerWebSpaceType).length > 0"
              v-for="(type, index) in getSortedKeys(licenseUsage.domainNamesPerWebSpaceType)"
              :class="{'mb-3': index !== getSortedKeys(licenseUsage.domainNamesPerWebSpaceType).length - 1}"
              :key="index">
              <h3 class="sub-title mb-3"><span>{{$lang.license.type}}:</span> {{type}}</h3>
              <div class="v-table__overflow">
                <table class="v-datatable v-table theme--light">
                  <thead>
                    <tr>
                      <th class="index-w">#</th>
                      <th>{{$lang.license.domainNames}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{index + 1}}</td>
                      <td class="success--text">{{licenseUsage.domainNamesPerWebSpaceType[type].join(', ')}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
          <div v-else>No data available.</div>
        </template>
      </v-flex>

      <v-flex v-if="licenseUsage" xs12 px-3 py-3>
        <h2 class="title mb-3">{{$lang.license.webShopResourceByType}}</h2>
        <template v-if='licenseUsage.type === "monthlyaggregated"'>
          <template v-if="licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel">
            <div
              v-if="webshopResPerSub.length > 0"
              v-for="(data, index) in webshopResPerSub"
              :class="{'mb-3': index !== webshopResPerSub.length - 1}"
              :key="index">
              <h3 class="sub-title mb-3"><span>{{$lang.license.type}}:</span> {{data.type}}</h3>
              <v-data-table
                :headers="webshopResPerSubHeaders"
                :items="data.companies"
                hide-actions
                class="elevation-0 my-table"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th class="bottomHeader column text-xs-left">#</th>
                    <th class="bottomHeader column text-xs-left">{{$lang.license.companyName}}</th>
                    <th class="bottomHeader column text-xs-left">{{$lang.license.webShopResourceName}}</th>
                    <th class="bottomHeader column text-xs-left">{{$lang.license.webShopResourceId}}</th>
                    <th class="customHeader">
                      <td class="topHeader">{{$lang.header.webshop}}</td>
                      <td class="bottomHeader column" role="columnheader" scope="col">{{$lang.license.orders}}</td>
                    </th>
                    <th class="bottomHeader column" role="columnheader" scope="col">{{$lang.license.totalAmount}}</th>
                    <th class="customHeader">
                      <td class="topHeader">{{$lang.header.orderingApp}}</td>
                      <td class="bottomHeader column" role="columnheader" scope="col">{{$lang.license.orders}}</td>
                    </th>
                    <th class="bottomHeader column" role="columnheader" scope="col">{{$lang.license.totalAmount}}</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td class="index-w">{{ props.index + 1}}</td>
                  <td class="width-adj">{{ props.item.companyName }}</td>
                  <td class="width-adj">{{ props.item.webShopResourceName}}</td>
                  <td>{{ props.item.webShopResourceId}}</td>
                  <td class="success--text">{{ getOrderData(props.item.ordersData, 'webshop', 'noOfOrders') }}</td>
                  <td class="success--text">{{ getOrderData(props.item.ordersData, 'webshop', 'ordersSum') }}</td>
                  <td class="success--text">{{ getOrderData(props.item.ordersData, 'ordering app', 'noOfOrders')}}</td>
                  <td class="success--text">{{ getOrderData(props.item.ordersData, 'ordering app', 'ordersSum')}}</td>
                </template>
              </v-data-table>
            </div>
          </template>
          <div v-else>No data available.</div>
        </template>

        <template v-if='licenseUsage.type === "daily" || licenseUsage.type === "monthly"'>
          <template v-if="licenseUsage.webShopResourcesPerSubscriptionModel">
            <div
              v-if="getSortedKeys(licenseUsage.webShopResourcesPerSubscriptionModel).length > 0"
              v-for="(type, index) in getSortedKeys(licenseUsage.webShopResourcesPerSubscriptionModel)"
              :class="{'mb-3': index !== getSortedKeys(licenseUsage.webShopResourcesPerSubscriptionModel).length - 1}"
              :key="index">
              <h3 class="sub-title mb-2"><span>{{$lang.license.type}}:</span> {{type}}</h3>
              <div class="v-table__overflow">
                <table class="v-datatable v-table theme--light">
                  <thead>
                    <tr>
                      <th class="index-w">#</th>
                      <th>{{$lang.license.webShopResourceName}}</th>
                      <th>{{$lang.license.webShopResourceId}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(resource, index2) in licenseUsage.webShopResourcesPerSubscriptionModel[type]" :key="index2">
                      <td>{{index2 + 1}}</td>
                      <td class="success--text width-adj">{{resource.webShopResourceName}}</td>
                      <td class="success--text">{{resource.webShopResourceId}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
          <div v-else>No data available.</div>
        </template>
      </v-flex>

      <v-btn
        flat
        @click="$emit('close')">
        <v-icon>keyboard_arrow_left</v-icon>
        {{$lang.actions.close}}
      </v-btn>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['licenseReportDetails'],
    data() {
      return {
        err: '',
        licenseUsage: null,
        months: [
          {value: '1', text: this.$lang.labels.january},
          {value: '2', text: this.$lang.labels.february},
          {value: '3', text: this.$lang.labels.march},
          {value: '4', text: this.$lang.labels.april},
          {value: '5', text: this.$lang.labels.may},
          {value: '6', text: this.$lang.labels.june},
          {value: '7', text: this.$lang.labels.july},
          {value: '8', text: this.$lang.labels.august},
          {value: '9', text: this.$lang.labels.september},
          {value: '10', text: this.$lang.labels.october},
          {value: '11', text: this.$lang.labels.november},
          {value: '12', text: this.$lang.labels.december},
        ],
        userCOuntPerLTHeaders: [
          {text: '#', value: '', align: 'left', sortable: false },
          {text: this.$lang.license.companyName, value: 'companyName', align: 'left', sortable: false },
          {text: this.$lang.license.concUsers, value: 'noOfConcurrentUsers', align: 'center', sortable: false },
        ],
        domainsPerWSHeaders: [
          {text: '#', value: '', align: 'left', sortable: false },
          {text: this.$lang.license.companyName, value: 'companyName', align: 'left', sortable: false },
          {text: this.$lang.license.domainNames, value: 'domainNames', align: 'left', sortable: false },
        ],
      };
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      webshopResPerSub() {
        let array = [];
        if (!this.licenseUsage || !this.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel) return array;
        const keys = Object.keys(this.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel);
        if (keys.length === 0) return array;
        keys.sort(this.sortAlph());
        keys.forEach((key) => {
          array.push(Object.assign(
            {},
            {
              type: key,
              companies: this.companyToArray(
                this.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel[key],
                'webShopResources',
              ),
            },
          ));
        });
        return array;
      },
      aggUserCountPerLicenseType() {
        let array = [];
        if (!this.licenseUsage || !this.licenseUsage.aggregateUserCountsPerLicenseType) return array;
        const keys = Object.keys(this.licenseUsage.aggregateUserCountsPerLicenseType);
        if (keys.length === 0) return array;
        keys.sort(this.sortAlph());
        keys.forEach((key) => {
          array.push(Object.assign(
            {},
            {
              type: key,
              companies: this.objToArr(
                this.licenseUsage.aggregateUserCountsPerLicenseType[key]
              )
            },
          ));
        });
        return array;
      },
      userCountPerLicenseType() {
        let array = [];
        if (!this.licenseUsage || !this.licenseUsage.userCountsPerLicenseType) return array;
        const keys = Object.keys(this.licenseUsage.userCountsPerLicenseType);
        if (keys.length === 0) return array;
        keys.sort(this.sortAlph());
        keys.forEach((key) => {
          array.push(Object.assign(
            {},
            {
              type: key,
              companies: this.objToArr(
                this.licenseUsage.userCountsPerLicenseType[key]
              )
            },
          ));
        });
        return array;
      },
      aggDomainsPerWebSpace() {
        let array = [];
        if (!this.licenseUsage || !this.licenseUsage.aggregateDomainNamesPerWebSpaceType) return array;
        const keys = Object.keys(this.licenseUsage.aggregateDomainNamesPerWebSpaceType);
        if (keys.length === 0) return array;
        keys.sort(this.sortAlph());
        keys.forEach((key) => {
          array.push(Object.assign(
            {},
            {
              type: key,
              companies: this.objToArr(
                this.licenseUsage.aggregateDomainNamesPerWebSpaceType[key]
              )
            },
          ));
        });
        return array;
      },
      counter() {
        let sum = 0;
        if (this.aggUserCountPerLicenseType) {
          this.aggUserCountPerLicenseType.forEach(entry => {
            if (entry.type === 'prod') {
              entry.companies.forEach(company => {
                sum += 1;
                if (company.noOfConcurrentUsers) {
                  sum += company.noOfConcurrentUsers;
                }
                if (company.noOfConcurrentUsers > 0) {
                  sum -= 1;
                }
              });
            }
          });
        }
        if (this.aggDomainsPerWebSpace) {
          this.aggDomainsPerWebSpace.forEach(type => {
            type.companies.forEach(company => sum += 0.5)
          })
        }
        if (this.licenseUsage.webShopResourceDetails && this.licenseUsage.webShopResourceDetails.noOfActiveWebShopResources) {
          sum += this.licenseUsage.webShopResourceDetails.noOfActiveWebShopResources;
        }
        if (sum < 0) {
          sum = 0;
        }
        return sum;
      }
    },
    methods: {
      getOrderData(parent, object, key) {
        return !parent || !parent[object] ? '-' : parent[object][key];
      },
      companyToArray(type, param) {
        if (!type) return [];
        let array = [];
        const keys = Object.keys(type);
        keys.sort(this.sortAlph());
        keys.forEach((key) => {
          const company = Object.assign({}, param ? type[key][param] : type[key]);
          const companyKeys = Object.keys(company);
          companyKeys.sort(this.sortAlph());
          companyKeys.forEach(companyKey =>
            array.push(Object.assign({}, company[companyKey], { companyName: key })));
        });
        return array;
      },
      objToArr(type) {
        if (!type) return [];
        let array = [];
        const keys = Object.keys(type);
        keys.sort(this.sortAlph());
        keys.forEach(key =>
          array.push(Object.assign({}, type[key], { companyName: key })));
        return array;
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      getSortedKeys(obj) {
        const keys = Object.keys(obj);
        keys.sort(this.sortAlph());
        return keys;
      },
      sortAlph(prop) {
        return (a, b) => {
          const keya = prop ? a[prop].toUpperCase() : a.toUpperCase();
          const keyb = prop ? b[prop].toUpperCase() : b.toUpperCase();
          if (keya < keyb) return -1;
          return (keya > keyb) ? 1 : 0;
        }
      },
    },
    created() {
      this.$http.get(`licenseusage/${this.licenseReportDetails.type}/${this.licenseReportDetails.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.licenseUsage = res.body.licenseUsage;
            return;
          }
          this.err = res.body.statusText
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        })
    }
  };
</script>

<style lang="scss">
  .my-table thead {
    th {
      padding: 0 12px !important;
      opacity: .75 !important;
    }
    .topHeader {
      position: absolute;
      top: 8px;
      font-size: 15px;
      right: -45%;
      width: 100%;
      display: block
    }
    .bottomHeader {
      padding: 18px 24px 0 24px !important;
    }
  }
  .my-table thead th:first-of-type {
    width: 20px !important;
  }
  .my-table {
    border: 1px solid rgba(0,0,0,.12) !important;
    .customHeader {
      position: relative;
      padding: 0 !important;
      td.bottomHeader {
        padding: 18px 24px 0 24px !important;
        display: block;
      }
    }
    thead tr:first-of-type {
      height: 60px !important;
    }
  }
  .index-w {
    width: 20px !important;
  }
</style>
<style lang="scss" scoped>
  .width-adj {
    width: 300px;
    min-width: 300px;
  }

  table {
    width: 100%;
    border-collapse: collapse !important;
    text-align: left;
    border: 1px solid rgba(0,0,0,.12) !important;
    th {
      opacity: .75 !important;
    }
    th, td {
     padding: 12px !important;
    }
    tr {
      height: 48px !important;
    }
    tbody {
      th {
        width: 300px;
      }
    }
  }
  .title {
    font-size: 1.2rem;
    opacity: .75;
    font-weight: 700;
  }
  .sub-title {
    font-weight: 700;
    opacity: .75;
    font-size: 1.1rem;
    span {
      color: blue;
    }
  }
  .month-year {
    p {
      font-size: 24px;
      color: #FFB300;
    }
    span {
      color: rgba(#000, 0.67);
    }
  }
</style>




// WEBPACK FOOTER //
// LicenseReportDetailsModal.vue?d844c650